export default __webpack_public_path__ + "images/0x74ccbe53f77b08632ce0cb91d3a545bf6b8e0979.png";